module.exports = __webpack_public_path__ + "media/images/v2/icon8-a236faea9403039c2f65243e751cabeb.png";